var _path, _line, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMesialHinge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2358 24.9687C20.3635 24.9896 20.4858 25 20.6081 25C21.5496 25 22.3475 24.3419 22.5709 23.4384C23.3581 20.2317 25.5815 12.5649 25.5815 10.5803C25.5815 8.0525 23.4911 6 20.9166 6C20.2624 6 19.6401 6.13057 19.0762 6.37081C18.6028 6.56927 18.0922 6.67372 17.5815 6.67372C17.0709 6.67372 16.5603 6.57449 16.0869 6.37081C15.523 6.13057 14.9007 6 14.2464 6C11.672 6 9.58154 8.0525 9.58154 10.5803C9.58154 12.3194 11.7837 20.2317 12.5549 23.4384C12.773 24.3419 13.5709 25 14.5177 25C14.6401 25 14.7677 24.9896 14.8954 24.9634C15.8528 24.7859 16.5177 23.9241 16.5177 22.9684V20.7905C16.5177 19.9601 16.9858 19.5006 17.5656 19.5006C18.1454 19.5006 18.6135 19.9601 18.6135 20.5294V22.9684C18.6135 23.9241 19.2784 24.7911 20.2411 24.9687H20.2358Z",
    fill: "#707070"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25.0815,
    y1: 4,
    x2: 25.0815,
    y2: 27,
    stroke: "white",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0934 19.1013L17.9688 16.442L18.2281 22.2097L23.0934 19.1013ZM9.72984 9.5226C9.49098 9.44839 9.24707 9.49393 9.06028 9.55421C8.86098 9.61853 8.65306 9.72384 8.44851 9.85217C8.03791 10.1098 7.58735 10.4941 7.16827 10.9566C6.34109 11.8694 5.55255 13.1823 5.51919 14.5614C5.5022 15.2639 5.68241 15.9758 6.14237 16.6363C6.59904 17.2922 7.31239 17.8704 8.32064 18.346C10.3246 19.2913 13.5744 19.869 18.6017 19.8035L18.5886 18.8036C13.6126 18.8684 10.5451 18.2896 8.74726 17.4416C7.85459 17.0205 7.29587 16.5429 6.96302 16.0649C6.63344 15.5916 6.50666 15.0916 6.5189 14.5855C6.54401 13.5475 7.15881 12.4563 7.9093 11.628C8.27905 11.22 8.66091 10.8994 8.97999 10.6992C9.14028 10.5987 9.27151 10.5368 9.3674 10.5059C9.47579 10.4709 9.48309 10.4931 9.43316 10.4776L9.72984 9.5226Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMesialHinge);
export default __webpack_public_path__ + "static/media/Icon_Mesial_Hinge.7cd24837e90c97cf62636dedacb58aa7.svg";
export { ForwardRef as ReactComponent };